import { WaitlistTable } from '@/components/tra/WaitlistTable';

export default function WaitlistListPage() {
  return <WaitlistTable />;
}
